import mandatoryEngineInputs from '@enums/mandatory-engine-inputs';
import featureFlagsMixin from './featureFlags';
import { useForecastVolume, enableMarginInitialisation } from '@enums/feature-flags';

const { mapValues } = require('lodash');

const mixin = {
  mixins: [featureFlagsMixin],
  methods: {
    getEngineInputsTranslations() {
      const translations = mapValues(mandatoryEngineInputs, path => this.$t(path));
      if (!this.isFeatureFlagEnabled(useForecastVolume)) {
        delete translations.forecastVolume;
      }
      if (!this.isFeatureFlagEnabled(enableMarginInitialisation)) {
        delete translations.initialisedMargin;
      }
      return translations;
    },
  },
};

export default mixin;
